import { observer } from 'mobx-react-lite'
import RootStore from './store'
import { ProgressBar, PaperProvider } from 'react-native-paper'
import React, { useEffect } from 'react'
import Loading from './screens/Loading'
import { CookiesProvider } from 'react-cookie'
import cookies from './utils/service/cooker'
import { Provider as StoreProvider } from 'mobx-react'
import MessageProvider from './utils/helpers/MessageProvider'
import Screens from './screens'
import { View } from 'react-native'
import { theme } from '@linqpal/common-frontend'
import * as eva from '@eva-design/eva'
import { ApplicationProvider, IconRegistry } from '@ui-kitten/components'
import { theme as KittenTheme } from '@linqpal/components'
const { customTheme, evaMapping } = KittenTheme
import { EvaIconsPack } from '@ui-kitten/eva-icons'

const BusyProgress = observer(() => {
  return (
    <ProgressBar
      color={theme.commonColors.accentText}
      visible={RootStore.isBusy}
      indeterminate
    />
  )
})

const Ready = observer(function AppReady() {
  useEffect(() => {
    if (RootStore.isReady) {
      const logo = document.getElementById('logo')
      if (logo) logo.parentNode?.removeChild(logo)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [RootStore.isReady])
  if (!RootStore.isReady) return <Loading />
  return (
    <CookiesProvider cookies={cookies.getProvider()}>
      <StoreProvider store={RootStore}>
        <PaperProvider theme={theme.light}>
          <IconRegistry icons={EvaIconsPack} />
          <ApplicationProvider
            {...eva}
            theme={{ ...eva.light, ...customTheme }}
            customMapping={evaMapping}
          >
            <MessageProvider>
              <Screens />
              <View
                style={{
                  position: 'absolute',
                  zIndex: 100000,
                  top: 0,
                  left: 0,
                  right: 0,
                }}
              >
                <BusyProgress />
              </View>
            </MessageProvider>
          </ApplicationProvider>
        </PaperProvider>
      </StoreProvider>
    </CookiesProvider>
  )
})

export default Ready
